@if (selectedTabDv === 1 && (werknemerEntity$ | async)) {
  <form [formGroup]="dienstverbandFg">
    <snelstart-ui-date-form-control [disabledControl]="true"
                                    class="custom-input-250"
                                    formControlName="datumInDienst"
                                    id="datumInDienst"
                                    label="Datum indiensttreding"
    >
    </snelstart-ui-date-form-control>
    <snelstart-ui-text-form-control [disabledControl]="true"
                                    class="custom-input-250"
                                    formControlName="ikv"
                                    id="ikv"
                                    label="Nummer inkomstenverhouding"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-date-form-control class="custom-input-250"
                                    formControlName="datumUitDienst"
                                    id="datumUitDienst"
                                    label="Datum uitdiensttreding"
    >
    </snelstart-ui-date-form-control>
    @if (dienstverbandFg.getRawValue().datumUitDienst !== null) {
      <snelstart-ui-select-form-control [options]="optionsUitDienst"
                                        class="custom-input-250"
                                        formControlName="redenEindeArbeidsverhouding"
                                        id="redenEindeArbeidsverhouding"
                                        label="Reden uitdiensttreding"
      >
      </snelstart-ui-select-form-control>
    }
  </form>
}

